<mat-card class="account-settings-container">
  <div class="account-header">
    <h2>Configurações da Conta - Perfil</h2>
    <mat-tab-group>
      <mat-tab label="Perfil"></mat-tab>
      <mat-tab label="Cobrança"></mat-tab>
      <mat-tab label="Segurança"></mat-tab>
      <mat-tab label="Notificações"></mat-tab>
    </mat-tab-group>
  </div>
  <div class="account-content">
    <div class="profile-picture-section">
      <mat-card class="profile-card">
        <img
          [src]="imagePreview || 'assets/images/default-profile.jpeg'"
          alt="Profile Image"
          class="profile-image"
        />
        <p class="profile-note">JPG ou PNG com tamanho máximo de 5 MB</p>
        <button mat-raised-button color="primary" (click)="fileInput.click()">
          Mudar imagem
        </button>
        <input
          #fileInput
          type="file"
          (change)="onFileSelected($event)"
          hidden
        />
      </mat-card>
    </div>

    <div class="account-details-section">
      <mat-card class="details-card">
        <h3>Detalhes da Conta</h3>
        <form [formGroup]="accountForm" (ngSubmit)="onSubmit()">
          <mat-form-field appearance="fill">
            <mat-label>Nome de Usuário</mat-label>
            <input matInput formControlName="username" placeholder="username" />
          </mat-form-field>

          <div class="name-fields">
            <mat-form-field appearance="fill">
              <mat-label>Primeiro Nome</mat-label>
              <input matInput formControlName="firstName" />
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>Último nome</mat-label>
              <input matInput formControlName="lastName" />
            </mat-form-field>
          </div>

          <mat-form-field appearance="fill">
            <mat-label>Nome da Empresa</mat-label>
            <input matInput formControlName="organization" />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Localização</mat-label>
            <input matInput formControlName="location" />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>E-mail</mat-label>
            <input matInput formControlName="email" type="email" />
          </mat-form-field>

          <div class="contact-fields">
            <mat-form-field appearance="fill">
              <mat-label>Número de celular</mat-label>
              <input matInput formControlName="phone" />
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>Data de Nascimento</mat-label>
              <input matInput formControlName="birthday" type="date" />
            </mat-form-field>
          </div>

          <button mat-raised-button color="primary" type="submit">Salvar alterações</button>
        </form>
      </mat-card>
    </div>
  </div>
</mat-card>